module.exports = __webpack_public_path__ + "static/media/A good auto responder.22349f34.png";